<section class="container" *ngFor="let package of packages" id="{{package.tagRfid}}">
  <div class="details">
    <div class="col">
      <app-info-oc-or-nfe label="rfId" [value]="package.tagRfid"></app-info-oc-or-nfe>
    </div>
    <div class="row bottom">
      <section>
        <app-info-oc-or-nfe label="Altura" *ngIf="!package?.groundPositionGroupLevelName?.length"
          [value]="package.z >= 0 ? package.z + 'cm' : 'indefinida'">
        </app-info-oc-or-nfe>
        <app-info-oc-or-nfe label="Tipo" [value]="formatType(package.type)"></app-info-oc-or-nfe>
        <app-info-oc-or-nfe label="Estado" [value]="translatePalletState(package.state)"></app-info-oc-or-nfe>
      </section>
      <section class="btn-container">
        <button mat-raised-button (click)="openPalletDetails(package)">
          Dados Do Pallet
        </button>
      </section>
    </div>
  </div>
  <app-product-list [products]="package.skuGroups"></app-product-list>
</section>
